import { Init } from "@pdfking/reactivity/preact"
import { map, object_map, scan } from "@pdfking/rfunc"
import { CreateSingleton } from "@pdfking/tfunc"
import has_dom from "@pdfking/workflow/utils/has_dom"
import keyboard from "../constants/keyboard"

type KeyboardCallback = (e: KeyboardEvent) => void

const callbacks: KeyboardCallback[] = []

const key_state = CreateSingleton(() =>
  Init({
    data: map(() => false, keyboard),
    methods: {
      dispatch: (e: KeyboardEvent) => scan(f => f(e), callbacks),
      register: (f: KeyboardCallback) => callbacks.push(f),
    },
  })
)
const reverse_keyboard = object_map(
  v => v,
  (_v, k) => k,
  keyboard
)
const set_to = (value: boolean) => (event: KeyboardEvent) => {
  const prop = reverse_keyboard[event.keyCode]

  if (prop) key_state()[prop] = value

  key_state().dispatch(event)
}

export default key_state

if (has_dom()) {
  window.addEventListener("keydown", set_to(true))
  window.addEventListener("keyup", set_to(false))
}
